/**
 * hrisAccess — the live access answer for the signed-in account.
 *
 * The RULES are pure and live in hrisAccessRules.ts; this file is the thin
 * layer that reaches for the shared role config and for MSAL's identity, which
 * is what made the rules untestable when they lived together.
 */
import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { grantFor, pullSharedRoleConfig, subscribeRoleConfig } from "./hrisRoles";
import { resolveHrisAccess, type HrisAccess } from "./hrisAccessRules";

export * from "./hrisAccessRules";

/** This account's access, resolved against the current shared role config. */
export function hrisAccessFor(email?: string): HrisAccess {
  return resolveHrisAccess(email, grantFor(email));
}

export function useHrisAccess(): HrisAccess {
  const { accounts } = useMsal();
  const email = accounts[0]?.username;
  // The shared role config arrives asynchronously; re-resolve when it lands so
  // a newly assigned user doesn't have to reload to get their screens.
  const [, bump] = useState(0);
  useEffect(() => {
    pullSharedRoleConfig();
    return subscribeRoleConfig(() => bump((n) => n + 1));
  }, []);
  return hrisAccessFor(email);
}
